import React, { useState } from 'react';
import TopActionBar from '../../uikit/top_actionbar';
import Tabs from '../../uikit/tabs';
import PendingLogisticTable from './LogisticTable';
import PendingPOTable from './PoTable';
import DateSelector from '../accounts/DateSelector';
import { usePendingPO, usePendingLogistics } from './util';

export default function PendingActions() {
  const [activeTab, setActiveTab] = useState('po');
  const pageSize = 100
  // Hooks are the single source of truth (NO CHANGES)
  const pendingPO = usePendingPO(pageSize);
  const pendingLogistics = usePendingLogistics(pageSize);

  // Apply date filter only to active tab
  const handleDateChange = (fromDate, toDate) => {
    if (activeTab === 'po') {
      pendingPO.handleFilterChange({
        ...pendingPO.filters,
        fromDate,
        toDate,
      });
    } else {
      pendingLogistics.handleFilterChange({
        ...pendingLogistics.filters,
        fromDate,
        toDate,
      });
    }
  };

  return (
    <>
      <TopActionBar
        containerClassName="px-4"
        leftContent={
          <h2 className="p-2 font-semibold md:p-0 text-white">
            Pending Actions
          </h2>
        }
        rightContent={
          <DateSelector
            onDateChange={handleDateChange}
            buttonTitle="Apply"
            dateFormat2={true}
          />
        }
      />

      <Tabs
        tabs={[
          { label: 'Ready For PO', value: 'po' },
          { label: 'Ready For Logistics', value: 'logistics' },
        ]}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        {/* PO TAB */}
        {activeTab === 'po' && (
          <PendingPOTable
            data={pendingPO.data}
            isFirst={pendingPO.isFirst}
            isLast={pendingPO.isLast}
            page={pendingPO.page}
            pageSize={pageSize}
            fetchNextPage={pendingPO.fetchNextPage}
            fetchPreviousPage={pendingPO.fetchPreviousPage}
          />
        )}

        {/* LOGISTICS TAB */}

        {activeTab === 'logistics' && (
          <PendingLogisticTable
            data={pendingLogistics.data}
            isFirst={pendingLogistics.isFirst}
            isLast={pendingLogistics.isLast}
            page={pendingLogistics.page}
            pageSize={pageSize}
            fetchNextPage={pendingLogistics.fetchNextPage}
            fetchPreviousPage={pendingLogistics.fetchPreviousPage}
          />
        )}
      </Tabs>
    </>
  );
}
